import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

export const ReasonsCheckboxGroup = ({ name, onChange, reasons, value = [] }) => {
  const selectedReasons = Array.isArray(value) ? value : [];

  const handleReasonToggle = reason => (event, checked) => {
    const nextReasons = checked
      ? [...selectedReasons, reason]
      : selectedReasons.filter(currentReason => currentReason !== reason);

    onChange(nextReasons);
  };

  return (
    <FormGroup>
      {reasons.map(reason => (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={selectedReasons.includes(reason)}
              name={name}
              onChange={handleReasonToggle(reason)}
            />
          }
          key={reason}
          label={reason}
        />
      ))}
    </FormGroup>
  );
};
